import React from "react";
import bnb from "../assets/images/icon/BNB.png";
import { Tabs } from "@mantine/core";
import { TabList } from "@headlessui/react";
import { HiDotsVertical } from "react-icons/hi";

const AssetOverview = () => {
  return (
    <>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <div className="p-6 space-y-6 text-sm ">
          {/* Estimated Balance Section */}
          <div className="rounded-xl shadow-sm p-6">
            <div className="flex justify-between items-center">
              <div>
                <div className="text-sm">Estimated Balance</div>
                <div className="text-3xl font-semibold">0.00 BTC</div>
                <div className="text-xs">~ $0.00</div>
              </div>
              <div className="space-x-2">
                <button className="bg-gray-100 px-4 py-1 rounded-md text-sm hover:bg-gray-200">
                  Deposit
                </button>
                <button className="bg-gray-100 px-4 py-1 rounded-md text-sm hover:bg-gray-200">
                  Withdraw
                </button>
                <button className="bg-gray-100 px-4 py-1 rounded-md text-sm hover:bg-gray-200">
                  Transfer
                </button>
              </div>
            </div>
          </div>

          {/* My Assets Section */}
          <div className="rounded-xl shadow-sm p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">My Assets</h2>
              <a href="#" className="text-green-600 text-sm hover:underline">
                View All 350+ Coins
              </a>
            </div>

            {/* Tab view */}
            <div className="flex items-center border-b mb-4">
              <Tabs defaultValue="Coin View">
                <Tabs.List>
                  <Tabs.Tab value="Coin View">Coin View</Tabs.Tab>
                  <Tabs.Tab value="Account View">Account View</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="Coin View">
                  {/* Table header */}
                  <div className="grid grid-cols-8 text-xs font-semibold text-gray-400 mb-2 h-10 items-center">
                    <div className="col-span-2">Coin</div>
                    <div>Amount</div>
                    <div>Coin Price</div>
                    <div className="flex items-center gap-2">
                      Action
                      <input type="checkbox" className="ml-auto" />
                      <span className="text-xs">Hide assets &lt; 1 USD</span>
                    </div>
                  </div>

                  {/* Coin Row - BNB */}
                  <div className="grid grid-cols-8 items-center py-3 border-t">
                    <div className="col-span-2 flex items-center gap-2">
                      <img src={bnb} alt="BNB" className="w-6 h-6" />
                      <div>
                        <div className="font-semibold">BNB</div>
                        <div className="text-xs text-gray-500">BNB</div>
                      </div>
                    </div>
                    <div>
                      <div className="font-medium">0.00</div>
                      <div className="text-xs text-gray-500">$0.00</div>
                    </div>
                    <div>$766.02</div>
                    <div className="text-green-600 hover:underline cursor-pointer">
                      Cash In
                    </div>
                  </div>

                  {/* Coin Row - BTC */}
                  <div className="grid grid-cols-8 items-center py-3 border-t">
                    <div className="col-span-2 flex items-center gap-2">
                      <img src={bnb} alt="BTC" className="w-6 h-6" />
                      <div>
                        <div className="font-semibold">BTC</div>
                        <div className="text-xs text-gray-500">Bitcoin</div>
                      </div>
                    </div>
                    <div>
                      <div className="font-medium">0.00</div>
                      <div className="text-xs text-gray-500">$0.00</div>
                    </div>
                    <div>$114,496.00</div>
                    <div className="text-green-600 hover:underline cursor-pointer">
                      Cash In
                    </div>
                  </div>

                  {/* Coin Row - ETH */}
                  <div className="grid grid-cols-8 items-center py-3 border-t">
                    <div className="col-span-2 flex items-center gap-2">
                      <img src={bnb} alt="ETH" className="w-6 h-6" />
                      <div>
                        <div className="font-semibold">ETH</div>
                        <div className="text-xs text-gray-500">Ethereum</div>
                      </div>
                    </div>
                    <div>
                      <div className="font-medium">0.00</div>
                      <div className="text-xs text-gray-500">$0.00</div>
                    </div>
                    <div>$3,675.84</div>
                    <div className="text-green-600 hover:underline cursor-pointer">
                      Cash In
                    </div>
                  </div>

                  {/* Coin Row - USDT */}
                  <div className="grid grid-cols-8 items-center py-3 border-t">
                    <div className="col-span-2 flex items-center gap-2">
                      <img src={bnb} alt="USDT" className="w-6 h-6" />
                      <div>
                        <div className="font-semibold">USDT</div>
                        <div className="text-xs text-gray-500">TetherUS</div>
                      </div>
                    </div>
                    <div>
                      <div className="font-medium">0.00</div>
                      <div className="text-xs text-gray-500">$0.00</div>
                    </div>
                    <div>$1.00</div>
                    <div className="text-green-600 hover:underline cursor-pointer">
                      Cash In
                    </div>
                  </div>
                </Tabs.Panel>

                <Tabs.Panel value="Account View">
                  <div className="w-full">
                    {/* Table Header */}
                    <div className="grid grid-cols-4 text-xs font-semibold text-gray-400 border-b py-2">
                      <div>Account</div>
                      <div>Amount</div>
                      <div>Ratio</div>
                      <div>Action</div>
                    </div>

                    {/* Row 1 - Spot */}
                    <div className="grid grid-cols-4 items-center py-4 border-b w-full text-sm text-gray-700">
                      <div className="flex items-center gap-2">
                        <img
                          src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f4b0.svg"
                          alt="Spot"
                          className="w-5 h-5"
                        />
                        <span className="font-semibold">Spot</span>
                      </div>
                      <div>
                        <div className="text-gray-500">--</div>
                        <div>$0.00</div>
                      </div>
                      <div>-</div>
                      <div>
                        <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer" />
                      </div>
                    </div>

                    {/* Row 2 - Cross Margin */}
                    <div className="grid grid-cols-4 items-center py-4 border-b w-full text-sm text-gray-700">
                      <div className="flex items-center gap-2">
                        <img
                          src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/2694.svg"
                          alt="Cross"
                          className="w-5 h-5"
                        />
                        <span className="font-semibold">Cross Margin</span>
                      </div>
                      <div>
                        <div className="text-gray-500">--</div>
                        <div>$0.00</div>
                      </div>
                      <div>-</div>
                      <div>
                        <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer" />
                      </div>
                    </div>

                    {/* Row 3 - Isolated Margin */}
                    <div className="grid grid-cols-4 items-center py-4 w-full text-sm text-gray-700">
                      <div className="flex items-center gap-2">
                        <img
                          src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f4c8.svg"
                          alt="Isolated"
                          className="w-5 h-5"
                        />
                        <span className="font-semibold">Isolated Margin</span>
                      </div>
                      <div>
                        <div className="text-gray-500">--</div>
                        <div>$0.00</div>
                      </div>
                      <div>-</div>
                      <div>
                        <HiDotsVertical className="w-5 h-5 text-gray-500 cursor-pointer" />
                      </div>
                    </div>
                  </div>
                </Tabs.Panel>
              </Tabs>
            </div>
          </div>

          {/* Recent Transactions */}
          <div className="rounded-xl shadow-sm p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Recent Transactions</h2>
              <a href="#" className="text-sm hover:text-black">
                More
              </a>
            </div>

            <div className="grid grid-cols-4 text-xsfont-semibold mb-2">
              <div>Transactions</div>
              <div>Amount</div>
              <div>Date</div>
              <div>Status</div>
            </div>

            <div className="text-sm">No transactions found.</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetOverview;
